/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Chiputt Variant Selector Enhancements
   * - Adds tooltips to unavailable options explaining why
   * - Updates button text for unavailable combinations
   * - Shows size in meters for international customers
   */

  // Feet to meters conversion (1 ft = 0.3048 m)
  const FT_TO_M = {
    '1.5 ft': 0.45,
    '3 ft': 0.9,
    '8 ft': 2.4,
    '11 ft': 3.4,
    '14 ft': 4.3
  };

  // Debounce timer to prevent rapid repeated calls
  let updateTimer = null;
  let isUpdating = false;

  /**
   * Get selected width value
   */
  function getSelectedWidth() {
    const widthFieldsets = document.querySelectorAll('.radio__fieldset');
    for (const fieldset of widthFieldsets) {
      const legend = fieldset.closest('.selector-wrapper')?.querySelector('.radio__legend__label, legend');
      if (legend && legend.textContent.toLowerCase().includes('width')) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      }
    }
    return null;
  }

  /**
   * Get selected length value
   */
  function getSelectedLength() {
    const lengthFieldsets = document.querySelectorAll('.radio__fieldset');
    for (const fieldset of lengthFieldsets) {
      const legend = fieldset.closest('.selector-wrapper')?.querySelector('.radio__legend__label, legend');
      if (legend && legend.textContent.toLowerCase().includes('length')) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      }
    }
    return null;
  }

  /**
   * Show meter value for selected option next to Width/Length label
   */
  function updateMeterDisplay() {
    const meterLabels = document.querySelectorAll('[data-meter-display]');

    meterLabels.forEach(function(meterLabel) {
      const selector = meterLabel.closest('.selector-wrapper, .radio__fieldset, fieldset');
      if (!selector) return;

      const checked = selector.querySelector('input[type="radio"]:checked');
      const meters = checked ? FT_TO_M[checked.value] : null;
      const newText = meters ? '≈' + meters + 'm' : '';

      if (meterLabel.textContent !== newText) {
        meterLabel.textContent = newText;
      }
    });
  }

  /**
   * Update tooltips on unavailable options
   */
  function updateTooltips() {
    const selectedWidth = getSelectedWidth();
    const unavailableButtons = document.querySelectorAll('.radio__button.sold-out, .radio__button.unavailable');

    unavailableButtons.forEach(function(button) {
      const label = button.querySelector('.radio__label');
      const input = button.querySelector('input[type="radio"]');

      if (!label || !input) return;

      const optionValue = input.value;
      const fieldset = button.closest('.radio__fieldset');
      const wrapper = fieldset?.closest('.selector-wrapper');
      const legend = wrapper?.querySelector('.radio__legend__label, legend');

      if (legend && legend.textContent.toLowerCase().includes('length')) {
        var tooltipText = '';

        if (selectedWidth === '1.5 ft' && optionValue === '14 ft') {
          tooltipText = 'ONLY AVAILABLE IN 3 FT WIDTH';
        } else if (optionValue === '14 ft') {
          tooltipText = 'ONLY AVAILABLE IN 3 FT WIDTH';
        } else {
          tooltipText = 'NOT AVAILABLE WITH CURRENT SELECTION';
        }

        label.setAttribute('data-unavailable-tooltip', tooltipText);
      } else {
        label.setAttribute('data-unavailable-tooltip', 'NOT AVAILABLE WITH CURRENT SELECTION');
      }
    });
  }

  /**
   * Update the Add to Cart / Unavailable button text
   */
  function updateButtonText() {
    const selectedWidth = getSelectedWidth();
    const selectedLength = getSelectedLength();

    const submitBtn = document.querySelector('.product__submit__add .btn, .product__submit .btn--primary, [data-add-to-cart], .product-form__submit');

    if (!submitBtn) return;

    const btnText = submitBtn.querySelector('.btn__text, span') || submitBtn;
    const currentText = btnText.textContent.toLowerCase().trim();
    const isUnavailable = submitBtn.disabled ||
                          submitBtn.classList.contains('btn--sold-out') ||
                          currentText.includes('unavailable') ||
                          currentText.includes('sold out');

    if (isUnavailable && selectedWidth === '1.5 ft' && selectedLength === '14 ft') {
      btnText.textContent = 'Select 3 ft width for 14 ft length';
      submitBtn.classList.add('btn--unavailable-combo');
    } else if (!isUnavailable) {
      submitBtn.classList.remove('btn--unavailable-combo');
    }
  }

  /**
   * Instantly update 14 ft availability styling based on width
   */
  function updateInstantAvailability() {
    const selectedWidth = getSelectedWidth();

    // Find all 14 ft options
    const allButtons = document.querySelectorAll('.radio__button');
    allButtons.forEach(function(button) {
      const input = button.querySelector('input[type="radio"]');
      if (input && input.value === '14 ft') {
        if (selectedWidth === '3 ft') {
          // 14 ft IS available with 3 ft width - force available styling
          button.classList.add('chiputt-available');
          button.classList.remove('chiputt-unavailable');
        } else if (selectedWidth === '1.5 ft') {
          // 14 ft NOT available with 1.5 ft width - force unavailable styling
          button.classList.add('chiputt-unavailable');
          button.classList.remove('chiputt-available');
        }
      }
    });
  }

  /**
   * Debounced update function - prevents rapid repeated calls
   */
  function scheduleUpdate() {
    // Run instant availability check immediately (no debounce)
    updateInstantAvailability();

    if (updateTimer) {
      clearTimeout(updateTimer);
    }
    updateTimer = setTimeout(function() {
      if (isUpdating) return;
      isUpdating = true;

      updateTooltips();
      updateButtonText();
      updateMeterDisplay();

      isUpdating = false;
    }, 150);
  }

  /**
   * Initialize variant enhancements
   */
  function initVariantEnhancements() {
    // Check if we're on a product page
    if (!document.querySelector('.product-form, [data-product-form]')) return;

    // Initial update (no debounce needed)
    updateInstantAvailability();
    updateTooltips();
    updateButtonText();
    updateMeterDisplay();

    // Listen for variant changes with debouncing
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"][name^="options"]')) {
        scheduleUpdate();
      }
    });

    // Observe DOM changes but with debouncing to prevent loops
    const productForm = document.querySelector('.product-form, [data-product-form]');
    if (productForm) {
      const observer = new MutationObserver(function(mutations) {
        // Only trigger if it's not our own update
        if (!isUpdating) {
          scheduleUpdate();
        }
      });

      observer.observe(productForm, {
        childList: true,
        subtree: true
      });
    }
  }

  /**
   * Mobile tap-to-show tooltip
   */
  function initMobileTooltips() {
    let activeTooltip = null;

    document.addEventListener('click', function(e) {
      const unavailableButton = e.target.closest('.radio__button.sold-out, .radio__button.unavailable');

      if (unavailableButton) {
        const label = unavailableButton.querySelector('.radio__label');
        if (label && label.hasAttribute('data-unavailable-tooltip')) {
          e.preventDefault();

          // Hide any previously active tooltip
          if (activeTooltip && activeTooltip !== label) {
            activeTooltip.classList.remove('tooltip-active');
          }

          // Toggle this tooltip
          label.classList.toggle('tooltip-active');
          activeTooltip = label.classList.contains('tooltip-active') ? label : null;
        }
      } else {
        // Clicked elsewhere - hide active tooltip
        if (activeTooltip) {
          activeTooltip.classList.remove('tooltip-active');
          activeTooltip = null;
        }
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initVariantEnhancements();
      initMobileTooltips();
    });
  } else {
    initVariantEnhancements();
    initMobileTooltips();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* YouTube links open in a new tab (Jason 2026-07-17): the section button
   renderers emit no target attr, so video CTAs navigated in-tab and read
   as bounces. Delegated in capture phase so it also covers quick-view and
   future links; links that already set a target are left alone. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.target) return;
    var href = a.getAttribute('href') || '';
    if (/^https?:\/\/(www\.|m\.)?(youtube\.com|youtu\.be)\//i.test(href)) {
      a.target = '_blank';
      a.rel = a.rel ? a.rel + ' noopener' : 'noopener';
    }
  }, true);
})();
